import { defineStyle } from "@chakra-ui/react";

export const SubjectFilterComponentStyles = () => {
  return {
    mainContainer: defineStyle({
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      whiteSpace: "nowrap",
      minWidth: "min-content",
    }),
    activeButton: defineStyle({
      width: "max-content",
      bgColor: "#74727E",
      borderWidth: "1px",
      borderColor: "#E4E4E7",
      padding: "6px 12px",
      borderRadius: "20px",
      fontFamily: "Poppins",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
      color: "#fff",
      _hover: {
        bgColor: "#F3F3F3",
        color: "#777A75",
      },
    }),
    passiveButton: defineStyle({
      width: "max-content",
      bgColor: "#F3F3F3",
      borderWidth: "1px",
      borderColor: "#E4E4E7",
      padding: "6px 12px",
      borderRadius: "20px",
      fontFamily: "Poppins",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
      color: "#777A75",
      _hover: {
        bgColor: "#74727E",
        color: "#fff",
      },
    }),
  };
};
